// extracted by mini-css-extract-plugin
export default {"elementContainer":"Stack_elementContainer__gz+Hh","elements":"Stack_elements__N7Fw3","element":"Stack_element__bm3lJ"};